import { twMerge } from 'tailwind-merge';
import { TResultImageSchema } from '@/schemas/vehicule-check-result/result-image.schema';
import { NavigationArrow } from './components/NavigationArrow';
import { NavigationDot } from './components/NavigationDot';

interface ImageNavigationsProps {
  images: TResultImageSchema[];
  dotContainerClassName?: string;
  activeImageId: string;
  showDots?: boolean;
  disabled?: boolean;
  leftArrowClassName?: string;
  rightArrowClassName?: string;
  arrowClassName?: string;
  arrowIconClassName?: string;
  onLeftClick?: () => void;
  onRightClick?: () => void;
  onDotClick?: (imageId: string) => void;
}

export const ImageNavigations = ({
  images,
  dotContainerClassName,
  activeImageId,
  showDots = true,
  disabled,
  leftArrowClassName,
  rightArrowClassName,
  arrowClassName,
  arrowIconClassName,
  onLeftClick,
  onRightClick,
  onDotClick,
}: ImageNavigationsProps) => {
  return (
    <>
      <NavigationArrow
        direction="left"
        disabled={disabled}
        onClick={onLeftClick}
        leftArrowClassName={leftArrowClassName}
        rightArrowClassName={rightArrowClassName}
        arrowClassName={arrowClassName}
        arrowIconClassName={arrowIconClassName}
      />
      <NavigationArrow
        direction="right"
        disabled={disabled}
        onClick={onRightClick}
        leftArrowClassName={leftArrowClassName}
        rightArrowClassName={rightArrowClassName}
        arrowClassName={arrowClassName}
        arrowIconClassName={arrowIconClassName}
      />
      {showDots && (
        <div
          className={twMerge(
            'absolute left-1/2 -translate-x-1/2 bottom-[8px] py-1.5 px-2 bg-purple-5433FF rounded-[10px] w-max max-w-[calc(100%-12px)] flex flex-wrap justify-center items-center gap-[4.5px] shadow-lg',
            dotContainerClassName,
            disabled && 'bg-opacity-85 hover:cursor-not-allowed'
          )}
        >
          {images?.map((item) => (
            <NavigationDot
              key={item?.id}
              disabled={disabled}
              active={item?.id === activeImageId}
              onClick={() => onDotClick?.(item?.id)}
            />
          ))}
        </div>
      )}
    </>
  );
};
